"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } /** When your routing table is too long, you can split it into small modules **/
var memberManagement = {
  path: '/member',
  component: _layout.default,
  redirect: '/member/memberManagement',
  name: 'member',
  alwaysShow: true,
  meta: {
    title: '会员管理',
    icon: 'member'
  },
  children: [{
    path: 'memberManagement',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/member/memberManagement'));
      });
    },
    name: '会员列表',
    meta: {
      title: '会员列表',
      icon: ''
    }
  }, {
    path: 'member_label',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/member/MemberLabelIndex.vue'));
      });
    },
    name: '会员标签',
    meta: {
      title: '会员标签',
      icon: ''
    }
  }, {
    path: 'memberCancellation',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/member/memberCancellation'));
      });
    },
    name: '用户注销清单',
    meta: {
      title: '用户注销清单',
      icon: ''
    }
  }, {
    path: 'couponList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/member/couponList'));
      });
    },
    name: '优惠券管理',
    meta: {
      title: '优惠券管理',
      icon: ''
    }
  }, {
    path: 'couponDetail/:id',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/member/couponDetail'));
      });
    },
    name: '优惠券详情',
    meta: {
      title: '优惠券详情',
      icon: ''
    },
    hidden: true
  }, {
    path: 'memberRechargeRecord',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/member/memberRechargeRecord'));
      });
    },
    name: '用户充值记录',
    meta: {
      title: '用户充值记录',
      icon: ''
    }
  }]
};
var _default = exports.default = memberManagement;